/** Libellés de rotation sans limite : A…Z, AA…AZ, BA… */
export function alternatingSpotLabel(index: number): string {
  let remaining = index + 1
  let label = ''
  while (remaining > 0) {
    remaining -= 1
    label = String.fromCharCode(65 + (remaining % 26)) + label
    remaining = Math.floor(remaining / 26)
  }
  return label
}
